import React from 'react';
import GenericSetupPage from './GenericSetupPage';

const DisciplinePage = () => {
  const columns = [
    { key: 'code', label: 'Code' },
    { key: 'name', label: 'Discipline Name' },
    { key: 'description', label: 'Description' },
    { key: 'active', label: 'Active' },
  ];

  const initialData = [
    { id: '1', code: 'RN', name: 'Registered Nurse', description: 'Skilled nursing services provided by RN', active: 'Yes' },
    { id: '2', code: 'LPN', name: 'Licensed Practical Nurse', description: 'Skilled nursing services provided by LPN', active: 'Yes' },
    { id: '3', code: 'PT', name: 'Physical Therapy', description: 'Physical therapy services', active: 'Yes' },
    { id: '4', code: 'OT', name: 'Occupational Therapy', description: 'Occupational therapy services', active: 'Yes' },
    { id: '5', code: 'SLP', name: 'Speech Language Pathology', description: 'Speech therapy services', active: 'Yes' },
    { id: '6', code: 'MSW', name: 'Medical Social Worker', description: 'Medical social work services', active: 'Yes' },
    { id: '7', code: 'HHA', name: 'Home Health Aide', description: 'Home health aide services', active: 'Yes' },
  ];

  return (
    <GenericSetupPage
      title="Discipline"
      columns={columns}
      initialData={initialData}
      addButtonText="Add Discipline"
    />
  );
};

export default DisciplinePage;
